module.exports = __webpack_public_path__ + "static/media/Ooppah_Clube_My_Lash.d565b65e.pdf";